import { bl_sfa_sales_lead_file_upload_hdr_RowClass } from "../../../dbschema/bl_sfa_sales_lead_file_upload_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadFileUploadHdrContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_file_upload_hdr: bl_sfa_sales_lead_file_upload_hdr_RowClass = new bl_sfa_sales_lead_file_upload_hdr_RowClass()
}